import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CmsParagraphComponent, User, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subject, takeUntil, tap } from 'rxjs';
import { UserProfileService } from '../../../SGRE-custom/user-profile/services/user-profile.service';
import { selectUserRoles } from '../../store/shared-store/selectors/shared.selector';
import { ErrorTrackingService } from '../../services/error-page-tracking.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PurchaseTermsConditionTrackingService } from '../../services/purchase-terms-condition-tracking.service';
import { PrivacyPolicyTrackingService } from '../../../SGRE-custom/privacy-policy/services/privacy-policy-tracking.service';
import { CookiePolicyTrackingService } from '../../../SGRE-custom/cookie-policy/service/cookie-policy-tracking.service';
import { TermsOfUseTrackingService } from '../../services/terms-of-use-tracking.service';

@Component({
  selector: 'app-shared-paragraph',
  templateUrl: './shared-paragraph.component.html',
  styleUrl: './shared-paragraph.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedParagraphComponent implements OnInit, OnDestroy {
  private static hasTrackedPageReady = false;
  private static hasTrackedCookiePolicy = false;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    let anchor: HTMLAnchorElement | null = null;
    if (target.tagName === 'A') {
      anchor = target as HTMLAnchorElement;
    } else if (target.closest('A')) {
      anchor = target.closest('A');
    }
    const url = anchor?.getAttribute('data-parent');
    if (url) {
      this.windowRef.nativeWindow.open(
        `${this.windowRef.nativeWindow.location.origin}${url}`,
        '_blank'
      );
    }
  }
  public data$: Observable<CmsParagraphComponent>;
  public role = '';
  public userRole: string | string[] = '';
  public userRoles: string[];
  loginDisplay = new BehaviorSubject(false);
  user$: Observable<User | undefined>;
  private readonly userProfileService = inject(UserProfileService);
  unsubscribe$ = new Subject<void>();
  private hasTrackedErrorPage = false;
  private hasPurchaseTC = false;

  constructor(
    private _component: CmsComponentData<CmsParagraphComponent>,
    public sanitizer: DomSanitizer,
    private windowRef: WindowRef,
    private errorTrackingService: ErrorTrackingService,
    private trackingService: PurchaseTermsConditionTrackingService,
    private privacyPolicyTrackingService: PrivacyPolicyTrackingService,
    private cookiePolicyTrackingService: CookiePolicyTrackingService,
    private termsOfUseTrackingService: TermsOfUseTrackingService,
    private store: Store
  ) {

  }

  ngOnInit(): void {
    this.data$ = this._component.data$
      .pipe(
        tap((componentData) => {
        if (componentData?.uid === 'PrivacyPolicySection1ParagraphComponent' && !SharedParagraphComponent.hasTrackedPageReady) {
          this.privacyPolicyTrackingService.sendPageReadyData();
          SharedParagraphComponent.hasTrackedPageReady = true;
        }

        if (componentData?.uid === 'CookiePolicySection1ParagraphComponent' && !SharedParagraphComponent.hasTrackedPageReady) {
          this.cookiePolicyTrackingService.sendPageReadyData();
          SharedParagraphComponent.hasTrackedPageReady = true;
        }

        if (componentData?.uid === 'Section1ParagraphComponent' && !SharedParagraphComponent.hasTrackedPageReady) {
          this.termsOfUseTrackingService.pageLoadTrackingData();
          SharedParagraphComponent.hasTrackedPageReady = true;
        }

          if (componentData?.uid === 'NotFoundTextParagraphComponent' && !this.hasTrackedErrorPage) {
            this.errorTrackingService.trackErrorPageReady();
            this.hasTrackedErrorPage = true;
          }
          if (componentData?.uid === 'PTnCSections1to7ParagraphComponent' && !this.hasPurchaseTC) {
            this.hasPurchaseTC = true;
            this.trackingService.pageLoadTrackingData();
          }
        })
      );

    this.checkAccess();

    this.userProfileService?.getfethedUserProFileData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        const paragraph: any = this.windowRef.document.getElementsByTagName('app-privacy-policy-paragraph');
        if (paragraph && data) {
          if (data.userData.email !== '' && data.userData.isInternal) {
            paragraph[1].style.display = 'none';
          } else if (data.userData.email !== '' && !data.userData.isInternal) {
            paragraph[0].style.display = 'none';
          }
        }
      });
  }

  checkAccess() {
    this.store.pipe(select(selectUserRoles)).subscribe((userRoles) => {
      this.userRoles = userRoles;
    });
    this.userRole = this.userRoles;
    if (this.userRole?.includes('Requester')) {
      this.role = 'Requester';
    } else if (this.userRole?.includes('Purchaser')) {
      this.role = 'Purchaser';
    } else if (this.userRole?.includes('Customer Admin')) {
      this.role = 'Customer Admin';
    } else if (this.userRole?.includes('SGRE Admin')) {
      this.role = 'SGRE Admin';
    } else if (this.userRole?.includes('Sales Rep')) {
      this.role = 'Sales Rep';
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    document.removeEventListener('click', this.onClick);
  }
}
